import React from 'react';

import {
  SubscriptionsContext,
  SubscriptionsDispatchContext,
} from './SubscriptionsContext';

export { SubscriptionsProvider } from './SubscriptionsContext';

export function useSubscriptions() {
  const context = React.useContext(SubscriptionsContext);
  if (context === undefined) {
    throw new Error(
      'The useSubscriptions hook must be used within a SubscriptionsProvider.'
    );
  }
  return context;
}

export function useSubscriptionsDispatch() {
  const context = React.useContext(SubscriptionsDispatchContext);
  if (context === undefined) {
    throw new Error(
      'The useSubscriptionsDispatch hook must be used within a SubscriptionsProvider.'
    );
  }
  return context;
}
